module.exports = __webpack_public_path__ + "img/40ne.9129229f.svg";